import React from "react";

const FORM_URL = "/belgeler/Bursa_Trabzonlular_Dernegi_Egitim_Bursu_Basvuru_Formu.docx";

const DEVLET_TIP_FAKULTELERI = [
  "Hacettepe Üniversitesi Tıp Fakültesi",
  "İstanbul Üniversitesi-Cerrahpaşa Cerrahpaşa Tıp Fakültesi",
  "Ankara Üniversitesi Tıp Fakültesi",
  "İstanbul Üniversitesi İstanbul Tıp Fakültesi",
  "Gazi Üniversitesi Tıp Fakültesi",
  "Ege Üniversitesi Tıp Fakültesi",
  "Marmara Üniversitesi Tıp Fakültesi",
  "Ankara Yıldırım Beyazıt Üniversitesi Tıp Fakültesi",
  "Sağlık Bilimleri Üniversitesi Hamidiye Tıp Fakültesi",
  "Sağlık Bilimleri Üniversitesi Gülhane Tıp Fakültesi",
  "Sağlık Bilimleri Üniversitesi İzmir Tıp Fakültesi",
  "Sağlık Bilimleri Üniversitesi Hamidiye Uluslararası Tıp Fakültesi",
  "Dokuz Eylül Üniversitesi Tıp Fakültesi",
  "Akdeniz Üniversitesi Tıp Fakültesi",
  "Eskişehir Osmangazi Üniversitesi Tıp Fakültesi",
  "Çukurova Üniversitesi Tıp Fakültesi",
  "İstanbul Medeniyet Üniversitesi Tıp Fakültesi",
  "Bursa Uludağ Üniversitesi Tıp Fakültesi",
  "Ondokuz Mayıs Üniversitesi Tıp Fakültesi",
];

const GEREKLI_BELGELER = [
  "Güncel öğrenci belgesi",
  "Yerleşim yeri (ikametgâh) belgesi",
  "2026 YKS sonuç belgesi ve yerleştirme belgesi (üniversiteye yeni başlayan öğrenciler için)",
  "Güncel transkript (ara sınıf öğrencileri için)",
  "Başka kurumlardan alınan burs veya düzenli eğitim desteği varsa buna ilişkin bilgi/belge",
  "Dernek tarafından değerlendirme sırasında ayrıca talep edilebilecek gelir durumunu gösteren belgeler",
];

const BURSIYER_BEKLENTILERI = [
  "Her akademik dönemin sonunda güncel transkriptlerini derneğimize iletmeleri",
  "Öğrenciliklerinin devam ettiğini gösteren belgeleri talep edildiğinde sunmaları",
  "Eğitimlerine ve akademik başarılarına özen göstermeleri",
  "Her yıl en az bir gün Bursa Trabzonlular Derneği'ni ziyaret ederek dernek üyelerimiz ve mümkün olduğunda diğer bursiyerlerimizle bir araya gelmeleri",
  "Başka kurumlardan aldıkları burs veya düzenli eğitim desteklerinde önemli bir değişiklik olması hâlinde derneğimize bilgi vermeleri",
];

const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2 className="text-xl md:text-2xl font-bold text-text-primary mb-3 mt-10">{children}</h2>
);

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-text-muted text-sm md:text-base leading-relaxed mb-3">{children}</p>
);

const IndirButton: React.FC<{ className?: string }> = ({ className = "" }) => (
  <a
    href={FORM_URL}
    download
    className={`inline-flex items-center gap-2.5 bg-brand-bordo hover:bg-brand-bordo-dark text-white font-semibold px-6 py-3.5 rounded-lg border-2 border-brand-bordo-dark transition-colors shadow-sm ${className}`}
  >
    <i className="fa-solid fa-file-arrow-down text-lg" />
    Başvuru Formunu İndir
  </a>
);

const BursPage: React.FC = () => (
  <div className="min-h-screen bg-bg-page">
    {/* Hero */}
    <div className="bg-gradient-to-br from-[#0F172A] to-brand-bordo-dark py-16 text-white">
      <div className="w-full px-6 xl:px-16 text-center">
        <div className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2">
          Destek ve Katılım
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3">2026–2027 Eğitim Bursu Başvuruları</h1>
        <p className="text-white/70 max-w-2xl mx-auto">
          Başarıyı Birlikte Destekliyor, Geleceğe Birlikte Yatırım Yapıyoruz
        </p>
      </div>
    </div>

    {/* İçerik */}
    <section className="py-12 md:py-16 bg-bg-page">
      <div className="w-full px-6 xl:px-16">
        <div className="max-w-6xl mx-auto">
          {/* İndirme çağrısı — üstte */}
          <div className="bg-bg-surface border border-border-light rounded-xl p-5 md:p-6 mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div>
              <div className="font-bold text-text-primary">Online Burs Başvuru Formu</div>
              <div className="text-text-soft text-sm mt-0.5">
                Formu bilgisayarınıza indirip doldurabilirsiniz. (Word / .docx)
              </div>
            </div>
            <IndirButton className="flex-shrink-0" />
          </div>

          <P>
            Bursa Trabzonlular Derneği olarak eğitimin, bir gencin hayatını değiştirebilecek en güçlü
            değerlerden biri olduğuna inanıyoruz.
          </P>
          <P>
            İmkânlarımız sınırlı olsa da başarılı, çalışkan ve geleceğe umutla bakan gençlerimizin
            eğitim yolculuğuna katkıda bulunmayı; bugün destek verdiğimiz öğrencilerimizin yarın
            ülkemize, toplumumuza ve kendilerinden sonra gelen gençlere değer katmasını çok
            önemsiyoruz.
          </P>
          <P>
            Bu anlayışla, 2026–2027 eğitim döneminde belirlenen şartları taşıyan üniversite
            öğrencilerine Bursa Trabzonlular Derneği Eğitim Bursu verilecektir.
          </P>
          <P>
            Burs kontenjanımız, derneğimizin ve hayırseverlerimizin imkânları doğrultusunda
            sınırlıdır. Bu nedenle şartları sağlayan her öğrenciye burs verilemeyebilir. Başvurular
            başarı durumu, öğrencinin ve ailesinin ekonomik koşulları ve derneğimizin burs kontenjanı
            birlikte değerlendirilerek sonuçlandırılacaktır.
          </P>

          <SectionTitle>Kimler Başvurabilir?</SectionTitle>
          <P>Aşağıdaki iki gruptan birinde yer alan öğrenciler burs programımıza başvurabilir:</P>

          <h3 className="font-bold text-text-primary text-base mt-5 mb-2">
            1. YKS başarı sıralamasında ilk 4.000 içerisinde yer alan üniversite öğrencileri
          </h3>
          <P>
            2026 YKS sonucunda ilgili puan türünde Türkiye genelinde ilk 4.000 içerisinde yerleşmiş
            öğrenciler başvurabilir.
          </P>

          <h3 className="font-bold text-text-primary text-base mt-5 mb-2">
            2. Belirlenen devlet üniversitelerinin tıp fakültelerinde öğrenim gören öğrenciler
          </h3>
          <P>
            2026 yılı yerleştirme verilerine göre taban puanı 515 ve üzerinde olan devlet
            üniversitelerinin ilgili tıp programlarında öğrenim gören öğrenciler başvurabilir.
          </P>
          <P>2026 yılı için değerlendirmeye alınacak devlet üniversiteleri / tıp fakülteleri:</P>
          <ul className="list-disc pl-5 space-y-1 mb-3 text-text-muted text-sm md:text-base leading-relaxed columns-1 sm:columns-2">
            {DEVLET_TIP_FAKULTELERI.map((f) => (
              <li key={f} className="break-inside-avoid">{f}</li>
            ))}
          </ul>
          <P>
            İngilizce ve Türkçe programların puanları farklı olması hâlinde, öğrencinin kayıtlı olduğu
            programın 2026 taban puanı esas alınır.
          </P>

          <SectionTitle>Ekonomik Duruma İlişkin Koşul</SectionTitle>
          <P>
            Burs programımızın temel amaçlarından biri, sınırlı kaynaklarımızı gerçekten desteğe
            ihtiyaç duyan başarılı öğrencilere ulaştırabilmektir.
          </P>
          <P>
            Bu nedenle başvuru sahibinin başka kurum, vakıf, dernek, şirket veya kişilerden aldığı
            aylık toplam burs ve düzenli eğitim desteğinin <strong>10.000 TL'yi aşmaması</strong>{" "}
            gerekmektedir.
          </P>
          <P>
            Başka bir kurumdan burs almak tek başına başvuruya engel değildir. Aylık toplam destek
            miktarının doğru ve eksiksiz olarak beyan edilmesi yeterlidir.
          </P>

          <SectionTitle>Bursiyerlerimizden Beklentilerimiz</SectionTitle>
          <P>
            Bursa Trabzonlular Derneği bursu yalnızca maddi bir destek olarak değil, öğrencilerimizle
            uzun yıllar devam etmesini arzu ettiğimiz bir dayanışma bağı olarak görülmektedir.
          </P>
          <P>Bu nedenle burs almaya hak kazanan öğrencilerimizin;</P>
          <ul className="list-disc pl-5 space-y-1.5 mb-3 text-text-muted text-sm md:text-base leading-relaxed">
            {BURSIYER_BEKLENTILERI.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>
          <P>beklenmektedir.</P>
          <P>
            Bu buluşmaların amacı öğrencilerimizi denetlemek değil; bursiyerlerimizi tanımak,
            aramızdaki bağı güçlendirmek, onların fikirlerini dinlemek ve zaman içerisinde birbirini
            destekleyen güçlü bir mezun ve bursiyer topluluğu oluşturmaktır.
          </P>

          <SectionTitle>Bugünün Bursiyeri, Yarının Destekçisi</SectionTitle>
          <P>
            Bu bursun en önemli amaçlarından biri, iyiliğin bir kişide kalmayıp kuşaktan kuşağa devam
            etmesidir.
          </P>
          <P>
            Derneğimizden burs alan öğrencilerimizden hukuken bağlayıcı olmayan bir gönül sözü
            istiyoruz:
          </P>
          <blockquote className="border-l-4 border-brand-gold bg-bg-surface rounded-r-lg pl-4 pr-4 py-3 my-4 text-text-muted text-sm md:text-base italic leading-relaxed">
            "Eğitimimi tamamlayıp çalışma hayatına başladıktan ve kendi ekonomik düzenimi kurduktan
            sonra, imkânlarım elverdiği ölçüde başka bir öğrencinin eğitim yolculuğuna katkıda
            bulunmaya gayret edeceğim."
          </blockquote>
          <P>Bu bir borç, geri ödeme yükümlülüğü veya hukuki taahhüt değildir.</P>
          <P>
            Derneğimiz verdiği bursların ileride kendisine geri ödenmesini beklememektedir.
            Dileğimiz; bugün kendisine uzatılan elin, yarın imkân sahibi olduğunda başka bir gence
            uzatılmasıdır.
          </P>
          <P>
            Bu nedenle bursiyerlerimizin mezuniyetlerinden ve düzenli gelir elde etmeye
            başlamalarından iki yıl sonra, maddi durumlarının elvermesi hâlinde en az bir öğrencinin
            eğitimine kendi imkânları ölçüsünde katkı sağlamalarını gönülden arzu ediyoruz.
          </P>
          <P>
            <strong>Burs geri ödenmez; iyilik devam ettirilir.</strong>
          </P>

          <SectionTitle>Başvuru İçin Gerekli Belgeler</SectionTitle>
          <div className="flex items-start gap-3 bg-red-50 border-2 border-red-300 rounded-lg px-4 py-3 my-4">
            <i className="fa-solid fa-triangle-exclamation text-red-600 text-lg mt-0.5 flex-shrink-0" />
            <p className="text-red-700 font-bold text-sm md:text-base leading-relaxed">
              Başvuru sırasında aşağıdaki belgelerin elden getirilmesi gerekmektedir:
            </p>
          </div>
          <ul className="list-disc pl-5 space-y-1.5 mb-3 text-text-muted text-sm md:text-base leading-relaxed">
            {GEREKLI_BELGELER.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>
          <P>Eksik belgeyle yapılan başvurular değerlendirmeye alınmayabilir.</P>

          <SectionTitle>Sizi Tanımak İstiyoruz</SectionTitle>
          <P>
            Başvuru formunda aşağıdaki sorulara da yer veriyoruz; başvurunuzu değerlendirirken sizi
            daha yakından tanımamıza yardımcı olacaktır:
          </P>
          <ul className="list-disc pl-5 space-y-1.5 mb-3 text-text-muted text-sm md:text-base leading-relaxed">
            <li>Neden Bursa Trabzonlular Derneği bursuna başvuruyorsunuz?</li>
            <li>Eğitiminizi tamamladıktan sonra kendinizi nerede görüyorsunuz? Hedefleriniz nelerdir?</li>
            <li>
              Bugüne kadar yer aldığınız sosyal, kültürel, sportif veya gönüllülük faaliyetleri varsa
              kısaca anlatınız.
            </li>
            <li>
              Derneğimizin gençlere yönelik çalışmalarına ileride nasıl katkı sağlayabileceğinizi
              düşünüyorsunuz?
            </li>
          </ul>

          <SectionTitle>Son Söz</SectionTitle>
          <P>Sevgili Öğrencimiz,</P>
          <P>
            Bir sınavda elde edilen başarı yalnızca bir puandan veya sıralamadan ibaret değildir. O
            sonucun arkasında yıllarca verilen emek, vazgeçilmeyen hedefler ve yapılan fedakârlıklar
            vardır.
          </P>
          <P>
            Bursa Trabzonlular Derneği olarak imkânlarımız ölçüsünde bu emeğin yanında olmak
            istiyoruz.
          </P>
          <P>
            Belki bugün senin yoluna küçük bir katkı sağlayacağız. En büyük temennimiz ise yarın
            mesleğini eline aldığında, başarılı olduğunda ve kendi ayaklarının üzerinde durduğunda
            senin de başka bir gencin yolunu aydınlatman.
          </P>
          <P>Çünkü inanıyoruz ki;</P>
          <P>
            <strong>
              Bir öğrenciye verilen destek, yalnızca bir öğrencinin değil, geleceğin
              desteklenmesidir.
            </strong>
          </P>
          <p className="text-text-primary font-semibold mt-6">Bursa Trabzonlular Derneği Başkanı</p>
          <p className="text-text-muted">Orhan Aygün</p>

          {/* İndirme çağrısı — altta */}
          <div className="mt-10 pt-8 border-t border-border-light text-center">
            <p className="text-text-muted text-sm mb-4">
              Başvurmak için formu indirip doldurun, gerekli belgelerle birlikte derneğimize elden
              teslim edin.
            </p>
            <IndirButton />
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default BursPage;
